function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCheckCircleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 2a14.003 14.003 0 0114 14c0 7.732-6.268 14-14 14S2 23.731 2 16 8.268 2 16 2zm0 2C9.373 4 4 9.374 4 16c0 6.628 5.373 12 12 12s12-5.372 12-12A12.002 12.002 0 0016 4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.93 22L8 17.07l1.558-1.558 3.372 3.372L21.814 10l1.558 1.558L12.93 22z",
    fill: props.color
  }));
}

export default SvgIconCheckCircleOutline;